var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-show',{attrs:{"item":_vm.item}},[_c('va-field',{attrs:{"source":"request"}}),_c('va-field',{attrs:{"source":"answer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }